import React from 'react';
import './styles.css';

interface BottomSheetProps {
    isOpen: boolean;
    onClose: () => void;
    heading: string;
    children: React.ReactNode;
}

const BottomSheet: React.FC<BottomSheetProps> = ({ isOpen, onClose, heading, children }) => {


    return (
        <>
            {
                isOpen && <div className="bottom-sheet-backdrop" onClick={onClose} />
            }
            <div className={`bottom-sheet-container ${isOpen ? 'open' : ''}`}>
                <div className={`bottom-sheet `}>
                    <div className="bottom-sheet-header">
                        <h2>{heading}</h2>
                    </div>
                    <div className="bottom-sheet-content">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BottomSheet;